module.exports = __webpack_public_path__ + "img/s1.125fca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s1.png
// module id = gJZA
// module chunks = 1